import React from "react";
import { makeStyles } from "tss-react/mui";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useClasses = makeStyles()((theme) => ({
  dropzoneContentIcon: {
    marginBottom: theme.spacing(1.25)
  },
  dropzoneContentDefaultIcon: {
    fontSize: "3em"
  },
  dropzoneContentResultIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2.5),
    borderRadius: "100%"
  },
  dropzoneContentSuccessIcon: {
    backgroundColor: theme.palette.success.main,
    fontSize: "1.5em"
  },
  dropzoneContentRejectIcon: {
    backgroundColor: theme.custom.palette.status.bronze.main
  }
}));
function DropzoneContentDefaultIcon({ isDragOrDialogActive }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    Icon,
    {
      icon: CustomIcon.File,
      color: isDragOrDialogActive ? IconColor.Primary : IconColor.Secondary,
      className: cx(classes.dropzoneContentDefaultIcon, classes.dropzoneContentIcon)
    }
  );
}
function DropzoneContentSuccessIcon() {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    Icon,
    {
      icon: CustomIcon.Confirm,
      color: IconColor.PrimaryContrastText,
      className: cx(classes.dropzoneContentSuccessIcon, classes.dropzoneContentResultIcon, classes.dropzoneContentIcon)
    }
  );
}
function DropzoneContentFailedIcon() {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    Icon,
    {
      icon: CustomIcon.ExclamationPoint,
      color: IconColor.PrimaryContrastText,
      className: cx(classes.dropzoneContentRejectIcon, classes.dropzoneContentResultIcon, classes.dropzoneContentIcon)
    }
  );
}
function DropzoneContentIcon({ type, isDragOrDialogActive }) {
  const iconMapper = {
    default: /* @__PURE__ */ React.createElement(DropzoneContentDefaultIcon, { isDragOrDialogActive }),
    success: /* @__PURE__ */ React.createElement(DropzoneContentSuccessIcon, null),
    failed: /* @__PURE__ */ React.createElement(DropzoneContentFailedIcon, null)
  };
  return iconMapper[type];
}
export {
  DropzoneContentIcon
};
//# sourceMappingURL=DropzoneContentIcon.js.map
